module.exports = __webpack_public_path__ + "img/Statut_PartDeliveried.3a245f38.svg";